// extracted by mini-css-extract-plugin
export default {"redirectButton":"RedirectButton_redirectButton__VZshn","icon":"RedirectButton_icon__jgEUn"};